import type { OurWorkBudgetItem } from "@src/__generated__/urql-graphql";
import type { IOption } from "@src/components/ui-kit";

type toBudgetItemOptionsParams = {
  budgetItems: {
    id: OurWorkBudgetItem["id"];
    title: OurWorkBudgetItem["title"];
    category: Pick<OurWorkBudgetItem["category"], "name">;
  }[];
  modifier: (option: IOption) => IOption;
};

export const toBudgetItemOptions = (
  budgetItems: toBudgetItemOptionsParams["budgetItems"],
  modifier: toBudgetItemOptionsParams["modifier"] = (option) => option,
): IOption[] =>
  budgetItems.map((i) =>
    modifier({
      label: `${i.title} - ${i.category.name}`,
      value: i.id,
    }),
  );
